import React from "react";
import format from "date-fns/format";
import { useHistory } from "react-router-dom";

import TemplateIcon from "../../../components/uiElements/icons/onboardingIcons/TemplateIcon";
import { NO_DATA_FOUND } from "../../../constants";

const NoteTemplateList = ({
  searchedResult,
  templates,
  setEditMode,
  searchValue,
}) => {
  const fetchedTemplates = templates;
  
  const history = useHistory();
  return (
    <>
      {fetchedTemplates?.length === 0 ? (
        <p className="content-center m-auto not-found-image">
          <img
            src={NO_DATA_FOUND}
            width={366}
            height={300}
            alt="requests-not-found"
          />
        </p>
      ) : (
        <div className="note-templates ">
          <table class="table mt-2 mb-5">
            <thead>
              <tr>
                <th>Name</th>
                <th>Date Created</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {fetchedTemplates &&
                fetchedTemplates.map((x, i) => {
                  return (
                    <tr
                      key={i}
                      onClick={() =>
                        history.push(`${history.location.pathname}/${x.id}`)
                      }
                    >
                      <td>{x?.note_name?.replace(/&nbsp;/g, " ")}</td>
                      <td>
                        {format(new Date(x?.created_at), "MMMM dd, yyyy")}
                      </td>
                      <td
                        onClick={e => {
                          e.stopPropagation();
                        }}
                        style={{ "text-align": "right" }}
                      >
                        <span className="mr-5">
                          <TemplateIcon
                            type="editIcon"
                            color="var(--icon-color)"
                            onClick={() => {
                              history.push(
                                `${history.location.pathname}/${x.id}`
                              );
                              setEditMode();
                            }}
                          />
                        </span>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default NoteTemplateList;
